import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "transfer-content" }
const _hoisted_2 = { class: "form-item" }
const _hoisted_3 = { class: "selected-phones" }
const _hoisted_4 = { class: "form-item" }
const _hoisted_5 = { class: "form-item agreement" }

import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import request from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneTransferDialog',
  setup(__props, { expose: __expose }) {

const visible = ref(false);
const toUser = ref('');
const agreedToTerms = ref(false);
const selectedPhones = ref<any[]>([]);

const show = (phones: any[]) => {
  selectedPhones.value = phones;
  visible.value = true;
  toUser.value = '';
  agreedToTerms.value = false;
};

const handleClose = () => {
  visible.value = false;
};

const handleConfirm = async () => {
  if (!agreedToTerms.value) {
    ElMessage.warning('请勾选锦田云手机使用权转移协议');
    return;
  }
  if (!toUser.value) {
    ElMessage.warning('请输入接受方账号');
    return;
  }
  try {
    const idArray = selectedPhones.value.map(item => item.id);
    await request.post('/instances/transfer', {
      instance_use_id: idArray,
      to_user: toUser.value
    });
    ElMessage.success('云手机转移成功');
    handleClose();
  } catch (error) {
    console.error('转移失败:', error);
  }
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: "设备转移",
    width: "500px",
    onClose: handleClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: handleClose }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createTextVNode("取消", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !agreedToTerms.value,
        onClick: handleConfirm
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createTextVNode("确认转移", -1)
        ]))]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("label", null, "选择云手机", -1)),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPhones.value, (phone) => {
              return (_openBlock(), _createBlock(_component_el_tag, {
                key: phone.id,
                type: "primary",
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(phone.instance_name || `云机${phone.id}`), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("label", null, "请输入接受方账号", -1)),
          _createVNode(_component_el_input, {
            modelValue: toUser.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((toUser).value = $event)),
            placeholder: "手机号/用户名",
            clearable: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_checkbox, {
            modelValue: agreedToTerms.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((agreedToTerms).value = $event))
          }, null, 8, ["modelValue"]),
          _cache[5] || (_cache[5] = _createElementVNode("span", null, "我已阅读并同意《锦田云手机使用权转移协议》", -1))
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "explain-text" }, [
          _createElementVNode("div", null, "转移说明:"),
          _createElementVNode("div", null, "1.在进行设备转移操作时，设备剩余时间需要大于24小时"),
          _createElementVNode("div", null, "2.每台设备 24小时内只能进行1次转移操作"),
          _createElementVNode("div", null, "3.由于设备转移操作不可逆，在转移前请确认账号信息准确"),
          _createElementVNode("div", null, "注意:设备转移是转移你的设备到你其他的账号，而不是转移设备的时间!请合理且合法利用设备转移功能!")
        ], -1))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})